import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Actions
// import {
//   initalizeOnboarding,
//   updateForm,
// } from '../../../../actions/onboarding';

import {
  signUp,
  resetUserState
} from '../../../../actions/user'

// Components
import FormInput from '../../../../components/Global/Forms/FormInput';
import ChecklistFormInput from '../../../../components/Global/Forms/ChecklistFormInput';
import MaskedFormInput from '../../../../components/Global/Forms/MaskedFormInput';
import SelectFormInput from '../../../../components/Global/Forms/SelectFormInput';
import SplitInputContainer from '../../../../components/Global/Forms/SplitInputContainer';
import FlashMessage from '../../../../components/Global/FlashMessage';

// Utils
import {
  getStrippedNumberFromString,
  validateEmail,
  isValidPhoneNumber,
} from '../../../../utils/helpers';

class SignUpForm extends Component {

  state = {
    input: {
      role: 'athlete',
      athlete_first_name: '',
      athlete_last_name: '',
      athlete_email: '',
      athlete_phone_number: '',
      password: '',
      password_confirm: '',
      parent_first_name: '',
      parent_last_name: '',
      parent_phone_number: '',
      parent_email: '',
      terms: [{
        value: false,
        label: (
          <span>
            By checking this box, you agree to our <a
              href="https://lockerlinked.com/terms-of-use/"
              target="_blank"
              className="text-link"
              without="true" rel="noopener noreferrer"
            >
              terms of use
            </a>.
          </span>
        )
      }]
    },
    formErrors: {
      athlete_first_name: '',
      athlete_last_name: '',
      athlete_email: '',
      athlete_phone_number: '',
      password: '',
      password_confirm: '',
      parent_first_name: '',
      parent_last_name: '',
      parent_phone_number: '',
      parent_email: '',
      terms: '',
    },
    signUpErrorMessage: '',
    formIsValid: false,
    displayErrorMessages: false,
    userEmailDisabled: false,
    secondaryUserDataDisabled: false,
  }

  componentDidMount() {
    // this.props.initalizeOnboarding();
    // this.props.resetUser();
    this.initializeFromDefaultProps(this.props);
  }

  initializeFromDefaultProps = ({ userEmailDisabled, userEmail, secondaryUserData, secondaryUserDataDisabled }) => {
    const { input } = this.state;

    this.setState({
      input: {
        ...input,
        athlete_email: userEmail,
        parent_first_name: secondaryUserData ? secondaryUserData.first_name : '',
        parent_last_name: secondaryUserData ? secondaryUserData.last_name : '',
        parent_email: secondaryUserData ? secondaryUserData.email : '',
        parent_phone_number: secondaryUserData ? secondaryUserData.phone_number : '',
      },
      userEmailDisabled,
      secondaryUserDataDisabled,
    })
  }

  handleInputChange = (event) => {
    const { value, name } = event.target;

    if (name === 'role') {
      this.switchAthleteAndParentFieldValues()
    }

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        [name]: value
      }
    }), () => { this.updateFieldErrorMessage(name, value) });
  }

  switchAthleteAndParentFieldValues = () => {
    const { input, formErrors} = this.state

    this.setState({
      input: {
        ...input,
        athlete_first_name: input.parent_first_name,
        athlete_last_name: input.parent_last_name,
        athlete_email: input.parent_email,
        athlete_phone_number: input.parent_phone_number,
        parent_first_name: input.athlete_first_name,
        parent_last_name: input.athlete_last_name,
        parent_email: input.athlete_email,
        parent_phone_number: input.athlete_phone_number,
      },
      formErrors: {
        ...formErrors,
        athlete_first_name: formErrors.parent_first_name,
        athlete_last_name: formErrors.parent_last_name,
        athlete_email: formErrors.parent_email,
        athlete_phone_number: formErrors.parent_phone_number,
        parent_first_name: formErrors.athlete_first_name,
        parent_last_name: formErrors.athlete_last_name,
        parent_email: formErrors.athlete_email,
        parent_phone_number: formErrors.athlete_phone_number,
      }
    })
  }

  handleChecklistInputChange = (name, checkboxPosition) => {
    let checklistArray = [...this.state.input[name]]

    let updatedCheckbox = {
      value: !checklistArray[checkboxPosition].value,
      label: checklistArray[checkboxPosition].label
    }

    let newState = [
      ...checklistArray.slice( 0, checkboxPosition ),
      updatedCheckbox,
      ...checklistArray.slice( checkboxPosition + 1, checklistArray.length)
    ]

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        [name]: newState
      }
    }), () => { this.updateFieldErrorMessage(name, newState) });
  }

  handleSubmit = (event) => {
    event.preventDefault()

    if (this.isFormValid()) {
      const { input } = this.state
      const isAthlete = input.role === "athlete"

      const dataForSubmit = {
        role: input.role,
        password: input.password,
        athlete_email: input.athlete_email,
        athlete_first_name: input.athlete_first_name,
        athlete_last_name: input.athlete_last_name,
        athlete_phone_number: getStrippedNumberFromString(input.athlete_phone_number),
        parent_email: input.parent_email,
        parent_first_name: input.parent_first_name,
        parent_last_name: input.parent_last_name,
        parent_phone_number: getStrippedNumberFromString(input.parent_phone_number)
      }

      this.props.onSubmit({ dataForSubmit, isAthlete })
    } else {
      this.setFormErrorState()
    }
  }

  setFormErrorState = () => {
    window.scrollTo(0, 0)
    this.setSignUpError('Please correct any errors and submit again.')

    const { input, displayErrorMessages } = this.state;

    Object.keys(input).map((field, i) => {
      return this.updateFieldErrorMessage(field, input[field])
    })

    if (!this.state.formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  toggleErrorMessages() {
    const { displayErrorMessages } = this.state;

    this.setState(state => ({
      ...state,
      displayErrorMessages: !displayErrorMessages
    }));
  }

  isFormValid() {
    const { input } = this.state;

    let inputErrorIndex = Object.keys(input).map((field, i) => {
      return this.isFieldValid(field, input[field])
    }).indexOf(false)

    if (inputErrorIndex > -1) {
      return false;
    } else {
      return true;
    }
  }

  isFieldValid = (fieldName, value) => {
    const { input } = this.state;

    switch(fieldName) {
      case 'athlete_email':
      case 'parent_email':
        return validateEmail(value)
        // eslint-disable-next-line no-unreachable
        break;
      case 'password_confirm':
        return value.length > 0 && value === input.password ? true : false;
        // eslint-disable-next-line no-unreachable
        break;
      case 'athlete_phone_number':
      case 'parent_phone_number':
        return isValidPhoneNumber(value)
      case 'terms':
        return value[0].value
        // eslint-disable-next-line no-unreachable
        break;
      default:
        return value.length > 0
        // eslint-disable-next-line no-unreachable
        break;
    }
  }

  updateFieldErrorMessage = (fieldName, value) => {
    const { input } = this.state;
    let errorMessage = '';

    switch(fieldName) {
      case 'athlete_first_name':
      case 'parent_first_name':
        errorMessage = value.length > 0
          ? ''
          : 'Please enter first and last names';
        break;
      case 'athlete_last_name':
      case 'parent_last_name':
        errorMessage = value.length > 0
          ? ''
          : 'Please enter first and last names';
        break;
      case 'athlete_email':
      case 'parent_email':
        errorMessage = validateEmail(value)
          ? ''
          : 'Please enter a valid email'
        break;
      case 'password_confirm':
        errorMessage = value === input.password && value.length > 0
        ? ''
        : 'Please make sure passwords match';
        break;
      case 'athlete_phone_number':
      case 'parent_phone_number':
        errorMessage = isValidPhoneNumber(value)
        ? ''
        : 'Please enter a valid phone number'
        break;
      case 'role':
        break;
      case 'terms':
        errorMessage = value[0].value
        ? ''
        : 'Pleace accept terms of service to continue'
        break;
      default:
        errorMessage = value.length > 0
          ? ''
          : 'Please complete this field';
        break;
    }

    this.setState(state => ({
      ...state,
      formErrors: {
        ...state.formErrors,
        [fieldName]: errorMessage
      }
    }));
  }

  handleInputBlur = (event) => {
    const { value, name } = event.target;
    const { formIsValid, displayErrorMessages } = this.state;

    this.updateFieldErrorMessage(name, value);

    if (!formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  setSignUpError(message) {
    this.setState({
      signUpErrorMessage: message
    });
  }

  renderSignUpErrorMessage() {
    const { signUpErrorMessage } = this.state;

    if (signUpErrorMessage === 'Email already used') {
      return (
        <FlashMessage optionalClasses='error'>
          <p>
            The email you entered has already been used.
          </p>
          <p>
            <Link to="/log-in" className="text-link">Try logging in</Link> or <Link to="/" className="text-link">reset your password</Link>
          </p>
        </FlashMessage>
      )
    } else {
      return signUpErrorMessage.length > 0
      ? (
        <FlashMessage optionalClasses='error'>
          {signUpErrorMessage}
        </FlashMessage>
      )
      : ''
    }
  }

  renderAthleteSpecificFields() {
    const {
      input,
      formErrors,
      displayErrorMessages,
      userEmailDisabled,
      secondaryUserDataDisabled,
    } = this.state;

    const emailDisabled = input.role === 'athlete' && userEmailDisabled
    const disableAdditionalFields = input.role === 'parent' && secondaryUserDataDisabled

    return (
      <Fragment>
        <SplitInputContainer
          showErrors={displayErrorMessages}
          errorMessages={[formErrors.athlete_first_name, formErrors.athlete_last_name]}
        >
          <FormInput
            label="First Name"
            placeholder="First Name"
            name="athlete_first_name"
            type="text"
            value={input.athlete_first_name}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.athlete_first_name}
            disabled={disableAdditionalFields}
          />
          <FormInput
            label="Last Name"
            placeholder="Last Name"
            name="athlete_last_name"
            type="text"
            value={input.athlete_last_name}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.athlete_last_name}
            disabled={disableAdditionalFields}
          />
        </SplitInputContainer>
        <FormInput
          label="Email Address"
          placeholder="Email Address"
          name="athlete_email"
          type="email"
          value={input.athlete_email}
          onChange={this.handleInputChange}
          onBlur={this.handleInputBlur}
          showError={displayErrorMessages}
          errorMessage={formErrors.athlete_email}
          disabled={emailDisabled || disableAdditionalFields}
        />
        <MaskedFormInput
          label="Mobile Phone"
          name="athlete_phone_number"
          mask={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
          placeholder="(555) 555-5555"
          placeholderChar={'\u2000'}
          guide={true}
          type="tel"
          value={input.athlete_phone_number}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.athlete_phone_number}
        />
      </Fragment>
    )
  }

  renderParentSpecificFields() {
    const {
      input,
      formErrors,
      displayErrorMessages,
      userEmailDisabled,
      secondaryUserDataDisabled,
    } = this.state;

    const emailDisabled = input.role === 'parent' && userEmailDisabled
    const disableAdditionalFields = input.role === 'athlete' && secondaryUserDataDisabled

    return (
      <Fragment>
        <SplitInputContainer
          showErrors={displayErrorMessages}
          errorMessages={[formErrors.parent_first_name, formErrors.parent_last_name]}
        >
          <FormInput
            label="First Name"
            placeholder="First Name"
            name="parent_first_name"
            type="text"
            value={input.parent_first_name}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.parent_first_name}
            disabled={disableAdditionalFields}
          />
          <FormInput
            label="Last Name"
            placeholder="Last Name"
            name="parent_last_name"
            type="text"
            value={input.parent_last_name}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.parent_last_name}
            disabled={disableAdditionalFields}
          />
        </SplitInputContainer>
        <FormInput
          label="Email Address"
          placeholder="Email Address"
          name="parent_email"
          type="email"
          value={input.parent_email}
          onChange={this.handleInputChange}
          onBlur={this.handleInputBlur}
          showError={displayErrorMessages}
          errorMessage={formErrors.parent_email}
          disabled={emailDisabled || disableAdditionalFields}
        />
        <MaskedFormInput
          label="Mobile Phone"
          name="parent_phone_number"
          mask={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
          placeholder="(555) 555-5555"
          placeholderChar={'\u2000'}
          guide={true}
          type="tel"
          value={input.parent_phone_number}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.parent_phone_number}
          disabled={disableAdditionalFields}
        />
      </Fragment>
    )
  }

  render() {
    const {
      input,
      formErrors,
      displayErrorMessages,
    } = this.state;
    const { submitting } = this.props
    const isParent = input.role === 'parent';

    return (
      <div>
        {this.renderSignUpErrorMessage()}
        <form onSubmit={this.handleSubmit}>
          <SelectFormInput
            label='I am a'
            name='role'
            value={input.role}
            onChange={this.handleInputChange}
            errorMessage={formErrors.role}
            optionalClasses="select-container"
            selectOptions={[
              {value: 'athlete', label: 'High School Athlete'},
              {value: 'parent', label: 'Parent / Guardian'}
            ]}
          >
          </SelectFormInput>
          { isParent
            ? this.renderParentSpecificFields()
            : this.renderAthleteSpecificFields()
          }
          <FormInput
            label="Password"
            placeholder="Password"
            name="password"
            type="password"
            value={input.password}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.password}
          />
          <FormInput
            label="Confirm Password"
            placeholder="Confirm Password"
            name="password_confirm"
            type="password"
            value={input.password_confirm}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.password_confirm}
          />
          <hr />
            <label className="emphasized-label">
              { isParent
                ? 'Athlete Information'
                : 'Parent/Guardian Information'
              }
            </label>
            { isParent
              ? this.renderAthleteSpecificFields()
              : this.renderParentSpecificFields()
            }
          <hr />
          <ChecklistFormInput
            label="Terms of Service"
            name="terms"
            selectedOption={input.terms}
            showError={displayErrorMessages}
            errorMessage={formErrors.terms}
            onChange={this.handleChecklistInputChange}
            options={input.terms}
          />
          <hr />
          {
            submitting
            ? <div className="spinner" />
            : (
              <input
                type="submit"
                value="Continue"
                onClick={this.handleSubmit}
              />
            )
          }
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    onboarding: state.onboarding
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    signUp: (user) => dispatch(signUp(user)),
    resetUser: () => dispatch(resetUserState()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpForm)



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Forms/_modules/SignUpForm.js